export const getters = {
  credentials: state => state.credentials,
};

export default getters;
